export const downloadFromString = (
  content: string,
  filename: string,
  contentType: string = 'data:text/plain;charset=utf-8'
) => {
  const a = document.createElement('a');
  a.setAttribute('download', filename);
  a.setAttribute('href', `${contentType},${encodeURIComponent(content)}`);

  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
};
